module.exports = __webpack_public_path__ + "@/assets/img/06.0aa89e15.svg";